<template>
    <v-chip :color="difficulty.background || 'grey lighten-4'" small label class="me-1 pe-2 small-text" style="height: 20px">
        <v-icon size="15" :color="difficulty.color" left class="me-1">mdi-{{level === 'extreme' ? 'license' : (level === 'difficult' ? 'star' : 'circle-double')}}</v-icon>
        <span :class="difficulty.background ? difficulty.background.split(' ')[0] + '--text text--darken-2' : ''">{{difficulty.text}}</span>
    </v-chip>
</template>

<script>
export default {
    props: {
        level: {},
    },
    data(){
        return {
            levels: [
                {
                    text: 'عادي',
                    value: 'normal',
                    color: '',
                },
                {
                    text: 'سهل جداً',
                    value: 'too_easy',
                    color: 'blue',
                    background: 'blue lighten-5',
                },
                {
                    text: 'سهل',
                    value: 'easy',
                    color: 'success',
                    background: 'green lighten-5',
                },
                {
                    text: 'متوسط',
                    value: 'medium',
                    color: 'warning',
                    background: 'orange lighten-5',
                },
                {
                    text: 'صعب',
                    value: 'difficult',
                    color: 'error',
                    background: 'red lighten-5',
                },
                {
                    text: 'شديد الصعوبة',
                    value: 'extreme',
                    color: 'error darken-2',
                    background: 'red lighten-5',
                }
            ],
        }
    },
    computed: {
        difficulty(){
            return this.levels.find(level=>level.value === this.level);
        }
    }

}
</script>

<style>

</style>
